<template>
  <div class="page">
    <c-source-page
      :table="table"
      :columns="columns"
      :filter="filter"
      :pagination="pagination"
      resource="custom_pages"
      createButtonText="新建页面"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Custompages extends Vue {

  pagination = {}

  filter = [
    {
      prop: 'name_cont',
      label: '页面名',
      form: {
        component: 'search'
      }
    },
    {
      prop: 'en_name_cont',
      label: '英文名',
      form: {
        component: 'search'
      }
    }
  ]

  table = {
    data: []
  };

  get columns() {
    return [
      {
        prop: 'id',
        label: '编号',
        width: 80
      },
      {
        prop: 'en_name',
        label: '页面英文名',
      },
      {
        prop: 'name',
        label: '页面名',
      },
      {
        prop: 'share_setting',
        label: '分享设置',
        renderCell(h, { row }) {
          const { share_cover, share_words } = row.share_setting || {};
          const renderImg = (src) => src && <el-image src={src} fit="cover" style={{ width: '50px', height: '50px' }} preview-src-list={[src]}></el-image>
          return (
            <div class="text-left">
              <p class="flex item-center">分享卡片图: {renderImg(share_cover)}</p>
              <p>分享文案: {share_words}</p>
            </div>
          )
        }
      },
      {
        prop: 'updated_at',
        label: '更新时间',
        width: 120,
        renderCell: 'time'
      },
      {
        prop: 'action',
        label: '操作',
        width: 100,
        detail: false,
        edit: true,
        extraAction: (h, { row }) => {
          return [
            {
              title: '设置分享',
              handler: () => this.$router.push({ name: 'custom_pages.config_share', params: { id: row.id } })
            },
            {
              title: '小程序页面路径',
              handler: () => this.$alert(row.front_end_url, '小程序页面路径')
            },
            {
              title: '修改页面名',
              handler: async () => {
                let name = await this.$prompt('页面名', '修改页面名', {
                  inputValue: row.name,
                  comfirmButtomText: '确定',
                  cancelButtomText: '取消'
                })
                name = name.value;
                await this.$request.put(`/custom_pages/${row.id}`, { name: name });
                this.$message.success('修改成功');
                this.fetchData();
              }
            },
            !row.should_not_destroy && {
              title: '删除',
              handler: async () => {
                await this.$request.delete(`/custom_pages/${row.id}`);
                this.$message('自定义页面删除成功');
                this.fetchData();
              }
            }
          ]
        }
      }
    ]
  }

  async mounted() {
    this.fetchData();
  }

  async fetchData(params = {}) {
    const { data, pagination } = await this.$request.get('/custom_pages', { params: { ...this.$route.query, ...params } });
    this.table.data = data;
    this.pagination = pagination;
  }
}
</script>
